module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-03-b3ca33c5d5a31f4dbd85dddb282e42ae.jpg";